import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './ProfilePresentationForm.jsx'
export default createSubmit(name)